module.exports = __webpack_public_path__ + "img/img1.77091e84.jpg";